




import { Component } from 'vue-property-decorator';
import ColoredButtons from './ColoredButtons';

@Component({})
export default class NpsGradientButtonsColored extends ColoredButtons {
  public get colors(): string[] {
    return [
      '#b72025',
      '#d02325',
      '#ef5323',
      '#f37022',
      '#faa821',
      '#ffc729',
      '#f1da18',
      '#e8e73d',
      '#c5d92c',
      '#67B64D',
      '#67b64d',
    ];
  }
}
